import Icon from "components/Icon"

import type { ComponentProps } from "."
import { Button } from "./styled"

const DEFAULT_BUTTON_SIZE = 28

const CloseButton = ({
  iconSize = "16px",
  label,
  onClick,
  size = DEFAULT_BUTTON_SIZE,
  tone = "neutral",
  type = "button",
  variant = "surface",
  customColor,
  ...rest
}: ComponentProps) => (
  <Button
    $customColor={customColor}
    $size={size}
    $tone={tone}
    $variant={variant}
    aria-label={label}
    onClick={onClick}
    type={type}
    {...rest}
  >
    <Icon
      aria-hidden
      data-testid="close-icon"
      group="fa6"
      name="FaXmark"
      size={iconSize}
    />
  </Button>
)

export default CloseButton
